import { graphql, Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import SectionTitle from './reusables/SectionTitle';
import smallBlueBlobImage from '../assets/smallBlueBlob.svg';

const Description = styled.div({
  whiteSpace: 'pre-line',
});
const Events = styled.div({});
const Event = styled.div({
  display: 'grid',
  gridTemplateColumns: '50px 1fr',
  columnGap: 10,
  alignItems: 'start',
  marginBottom: 30,
});

const DayNumber = styled.div({
  backgroundImage: `url(${smallBlueBlobImage})`,
  backgroundRepeat: 'no-repeat',
  width: 46,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontSize: 18,
  marginBottom: 5,
});

const EventDate = styled.div({
  textTransform: 'uppercase',
  textAlign: 'center',
});

export default function CalendarPanel({ events }) {
  return (
    <>
      <SectionTitle css={{ paddingTop: 0 }}>Kalendarium</SectionTitle>
      <Events>
        {events.map(({ node }) => {
          const [day, month] = node.date.split(' ');
          const navigation = !node.destination
            ? {}
            : node.destination.startsWith('/')
            ? { as: Link, to: node.destination }
            : {
                as: 'a',
                href: node.destination,
                target: '_blank',
                rel: 'noopener noreferrer',
              };

          return (
            <Event {...navigation} key={node.id}>
              <EventDate>
                <DayNumber>{day}</DayNumber>
                <div>{month}</div>
              </EventDate>
              <Description
                css={node.destination ? { textDecoration: 'underline' } : undefined}
              >
                {node.description?.description?.trim()}
              </Description>
            </Event>
          );
        })}
      </Events>
    </>
  );
}

export const query = graphql`
  fragment CalendarEventFields on ContentfulEvent {
    id
    date(formatString: "DD MMM")
    destination
    description {
      description
    }
  }
`;
